<div class="dash-page">
  <header class="dash-topbar">
    <div class="dash-logo">
      <div>
        <div class="dash-logo-name">UI Kit</div>
      </div>
    </div>
  </header>

  <p-tabView>
    <p-tabPanel header="CSS Components">
      <ng-template pTemplate="content">
        <app-css-uikit></app-css-uikit>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Dashboard">
      <ng-template pTemplate="content">
       <app-dashboard-uikit/>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="PrimeNG">
      <ng-template pTemplate="content">
        <!--<app-primeng-uikit></app-primeng-uikit>-->
      </ng-template>
    </p-tabPanel>
     <p-tabPanel header="AI Charts">
      <ng-template pTemplate="content">
        <app-ai-charts-uikit></app-ai-charts-uikit>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>
